module.exports = __webpack_public_path__ + "static/media/get-started-fr.79fd19da.png";